import CoreArticleAuthors from './CoreArticleAuthors';

export { type CoreArticleAuthorsProps } from './CoreArticleAuthors';
export default CoreArticleAuthors;
